var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
import PassengerCategory from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (values) {
            _this.data = values.map(function (item) { return new PassengerCategory(item); });
            _this.loaded = true;
        };
        this.push = function (value) {
            _this.data.push(new PassengerCategory(value));
        };
        this.replace = function (value) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
        this.splice = function (value) {
            console.log(value);
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value; }), 1);
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        // console.log('PassengerCategorys/Store - read')
        if (id)
            return api.get('passengercategories/' + id);
        return api.get('passengercategories').then(function (value) {
            // console.log('value', value)
            _this.set(value);
            return value;
        });
    };
    default_1.prototype.create = function (value) {
        return api.post('passengercategories', value).then(this.push);
    };
    default_1.prototype.update = function (id, value) {
        return api.put('passengercategories/' + id, value).then(this.replace);
    };
    default_1.prototype.delete = function (id) {
        return api.delete('passengercategories/' + id).then(this.splice);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('passengercategories/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    __decorate([
        action
    ], default_1.prototype, "splice", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/PassengerCategories/Store.ts
// module id = 711
// module chunks = 0